/**
 * Marca de "esta ficha se abrió desde un listado".
 *
 * La usa el enlace "Volver a vehículos": si el usuario llegó desde el listado,
 * volver tiene que ser un `router.back()` de verdad. Antes era un
 * `router.push`, que apilaba una entrada nueva en el historial —el botón Atrás
 * del navegador devolvía a la ficha, en bucle— y además scrolleaba al tope.
 * Con `back()` el navegador vuelve a la MISMA entrada del listado, que es la
 * que tiene guardada la posición.
 *
 * Si la ficha se abrió desde un link de Google o de WhatsApp, la marca no está
 * y el enlace vuelve a empujar la URL del listado, que es lo correcto: atrás no
 * hay ningún listado al que volver.
 */
const KEY = 'vehicles-from-list';

/**
 * Respuesta ya dada para cada ficha de ESTE documento.
 *
 * Es lo que hace que la lectura sea idempotente. Antes la marca se consumía en
 * un efecto de montaje y con StrictMode —o con cualquier remontaje— el primer
 * montaje se la llevaba y el segundo, que es el que queda vivo, la encontraba
 * vacía: el enlace volvía a empujar. Medido en el navegador.
 */
const answered = new Map<string, boolean>();

/** Deja la marca apuntando a la ficha que se está por abrir. */
export function markLeavingList(path: string) {
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // Safari en navegación privada tira al escribir: sin marca, el enlace se
    // comporta como antes.
  }
}

/** ¿Esta ficha se abrió desde el listado? Misma respuesta todas las veces. */
export function cameFromList(path: string): boolean {
  const cached = answered.get(path);
  if (cached !== undefined) return cached;

  let value = false;
  try {
    value = sessionStorage.getItem(KEY) === path;
    // Se borra en la primera lectura: la marca describe UNA entrada a la
    // ficha, no todas las que vengan después en la misma visita.
    if (value) sessionStorage.removeItem(KEY);
  } catch {
    value = false;
  }

  answered.set(path, value);
  return value;
}
